// The shop page (sections/main-collection, as <shop-page>): category chips, size and colour filters, sort and the
// address (?c= &size= &colour= &sort=), over the cards Liquid printed in our order (blocks/_shop-grid), of which it
// keeps the shown ones in the grid, in order; the band's title, line and note per category (worked out by
// blocks/_shop-band); the outfit tile's looks and place; the empty state. Pricing and stock come from Store; quick add, the look sheet and the bag are
// chrome.js. This file only filters, sorts and draws. The theme editor's redraw starts it afresh (UI.define).
(() => {
  'use strict';
  const S = window.Store, U = window.UI, esc = U.esc, money = U.money;
  const fill = (s, o) => Object.keys(o).reduce((t, k) => t.split('[' + k + ']').join(o[k]), s);
  const slug = s => String(s || '').trim().toLowerCase().replace(/\s+/g, '-');
  const hasSize = (p, size) => p.sizes.some(z => z.size === size && z.available);
  const json = el => { try { return JSON.parse(el.textContent); } catch (e) { return {}; } };
  // Each block prints its own words (script[data-shop-words], the owner's or ours). These are for a band hidden in the
  // editor (its counts also name the bar's count) and the section's two interface lines.
  const WORDS = { shop_one_piece: '1 piece', shop_pieces: '[n] pieces', shop_no_pieces: 'No pieces',
    filters_on: '[n] on', nothing_matches: 'Nothing matches these filters' };
  const SORTS = { featured: null, 'price-asc': (a, b) => a.price - b.price, 'price-desc': (a, b) => b.price - a.price };

  U.define('shop-page', {
    connect(signal) {
      const root = this, $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
      const W = Object.assign({}, WORDS, ...$$('script[data-shop-words]').map(json));
      const COPY = $('[data-shop-copy]') ? json($('[data-shop-copy]')) : {};
      const grid = $('#shopGrid'), empty = $('#shopEmpty'), count = $('#shopCount'), band = $('.shop-band');

      // ---------- catalogue ----------
      // A store collection page (/collections/summer26) lists only that collection's pieces, under its title; the category
      // chips then filter inside it. /collections/all lists everything.
      const COL = window.THEME && THEME.collection && THEME.collection.handle !== 'all' ? THEME.collection : null;
      const BASE = COL ? S.products.filter(p => (p.collections || []).includes(COL.handle)) : S.products;
      const shopUrl = c => (COL ? '/collections/' + encodeURIComponent(COL.handle) + (c === 'all' ? '' : '?c=' + c) : U.shopUrl(c));
      const CATS = [{ id: 'all', label: W.shop_chip_all }].concat(U.SHOP_CATS);
      const SIZES = [...new Set(BASE.flatMap(p => p.sizes.map(z => z.size)))];
      // our order is the grid's, as Liquid printed it (Featured, or the collection's own: sections/main-collection);
      // a piece it didn't print goes last
      const CARDS = new Map($$('#shopGrid > .pcard').map(el => [el.dataset.handle, el]));
      const ORDER = new Map([...CARDS.keys()].map((h, i) => [h, i])), rank = p => (ORDER.has(p.handle) ? ORDER.get(p.handle) : 1e9);
      const pool = c => BASE.filter(p => c === 'all' || p.category === c).sort((a, b) => rank(a) - rank(b));
      // One entry per colour name in a category, with a product to draw its cloth. A store product with no colour set
      // (noColour, its colour reads "One colour") has no swatch.
      const colours = c => {
        const seen = new Set();
        return pool(c).filter(p => !p.noColour && !seen.has(slug(p.colour)) && seen.add(slug(p.colour))).map(p => ({ id: slug(p.colour), name: p.colour, p }));
      };
      const pieces = n => (n === 1 ? W.shop_one_piece : n ? fill(W.shop_pieces, { n }) : W.shop_no_pieces);   // plain text
      const noun = c => W['shop_noun_' + c] || (CATS.find(x => x.id === c) || { label: '' }).label.toLowerCase();
      // a category's title, line and note: the band's (blocks/_shop-band), under a Category block's own words, except
      // on Shop all of a store collection (the collection's own title and description)
      const copy = c => {
        const k = COPY[c] || { title: (CATS.find(x => x.id === c) || { label: '' }).label, line: '', note: '' };
        const own = COL && c === 'all' ? null : $('.shop-line[data-c="' + CSS.escape(c) + '"]');
        return { title: (own && own.dataset.title) || k.title, line: (own && own.dataset.line) || k.line, note: k.note, own };
      };

      // ---------- state lives in the URL ----------
      function read() {
        const q = new URLSearchParams(location.search), c0 = U.pageCat();
        const c = CATS.some(x => x.id === c0) ? c0 : 'all';
        const size = (q.get('size') || '').toUpperCase(), colour = slug(q.get('colour')), sort = q.get('sort');
        return {
          c,
          size: SIZES.find(z => z.toUpperCase() === size) || null,   // "One size" and 30/32 too
          colour: colours(c).some(x => x.id === colour) ? colour : null,
          sort: Object.prototype.hasOwnProperty.call(SORTS, sort) ? sort : 'featured'
        };
      }
      // The page URL for a state: the category's own URL (/collections/all?c=), plus the filters.
      function query(s) {
        const q = new URLSearchParams();
        if (s.size) q.set('size', s.size);
        if (s.colour) q.set('colour', s.colour);
        if (s.sort !== 'featured') q.set('sort', s.sort);
        const base = shopUrl(s.c), rest = String(q);
        return rest ? base + (base.includes('?') ? '&' : '?') + rest : base;
      }
      // Switching category keeps the size and sort, and the colour if the new category has it.
      const inCat = (s, c) => ({ ...s, c, colour: colours(c).some(x => x.id === s.colour) ? s.colour : null });
      const matching = s => {
        const list = pool(s.c).filter(p => (!s.size || hasSize(p, s.size)) && (!s.colour || slug(p.colour) === s.colour));
        return SORTS[s.sort] ? list.sort(SORTS[s.sort]) : list;
      };

      let state = read();
      function go(next, push) {
        const newCat = next.c !== state.c;
        state = next;
        try { history[push ? 'pushState' : 'replaceState'](null, '', query(state)); } catch (e) { /* some setups refuse; the page still works */ }
        if (newCat) renderCategory();
        renderResults(true);
      }
      // the theme editor: picking a Category block shows its category
      this.pick = c => { if (c !== state.c && CATS.some(x => x.id === c)) go(inCat(state, c), false); };

      // ---------- markup ----------
      const LOOKS = U.LOOKS.map(L => ({ ...L, q: S.price(L.handles.map(h => ({ handle: h, qty: 1 }))) }));
      // the tile (blocks/_shop-outfit; one: a second stays hidden), with the looks; none left (a piece archived): no tile
      const tiles = $$('#shopGrid > .shop-look'), tile = LOOKS.length ? tiles[0] : null;
      tiles.forEach(t => { t.hidden = t !== tile; });
      if (tile) {
        tile.querySelector('ul').innerHTML = LOOKS.map(L => '<li><button class="shop-look-row" type="button" data-open-look="' + L.handles.join(',') + '" data-look-title="' + esc(L.name) + '">' +
          '<span class="cloths">' + L.handles.map(h => U.swatch(h)).join('') + '</span>' +
          '<span class="nm">' + esc(L.name) + '<span class="pc">' + esc(L.pieces) + '</span></span>' +
          '<span class="pr price">' + money(L.q.total) + '</span>' +
          '<span class="go" aria-hidden="true">' + U.icon('plus') + '</span></button></li>').join('');
        // our photo is the Grey look's still: shown only while that look is (UI.LOOKS drops a look with a piece gone) and
        // still has the pieces the photo shows (the jacket's Frequently bought with can change them: asShot)
        if (!LOOKS.some(L => L.id === 'grey' && L.asShot !== false)) tile.querySelector('[data-grey]')?.remove();
      }
      // n: cards in the grid. Long lists get the tile as a full row after the first four cards; short lists get it last,
      // filling what is left of the final row (2, 3 or 4 columns, per site.css .cards), or a full row when that would be one column.
      const span = (n, k) => (n >= 8 || !(n % k) || k - n % k === 1 ? k : k - n % k);
      // a card Liquid didn't print (it shouldn't happen): the JS one
      const card = p => {
        if (!CARDS.has(p.handle)) { const t = document.createElement('template'); t.innerHTML = U.productCard(p, { level: 2 }); CARDS.set(p.handle, t.content.firstElementChild); }
        return CARDS.get(p.handle);
      };
      function facetsHTML(sheet) {
        const id = sheet ? 'sheet' : 'inline';
        return '<div class="facet" role="group" aria-labelledby="' + id + 'Size"><p class="facet-label" id="' + id + 'Size">' + esc(W.shop_size) + '</p>' +
            '<div class="chips">' + SIZES.map(z => '<button class="chip" type="button" data-f="size" data-v="' + z + '" aria-pressed="false">' + z + '</button>').join('') + '</div>' +
            (sheet ? '<p class="field-note">' + esc(W.shop_size_note) + '</p>' : '') + '</div>' +
          '<div class="facet" role="group" aria-labelledby="' + id + 'Colour"><p class="facet-label" id="' + id + 'Colour">' + esc(W.shop_colour) + '<span class="facet-val" data-val></span></p>' +
            '<ul class="swatches">' + colours(state.c).map(x => '<li><button class="swatch" type="button" data-f="colour" data-v="' + x.id + '" aria-pressed="false"' +
              (sheet ? '>' + U.swatch(x.p) + esc(x.name) : ' aria-label="' + esc(x.name) + '" title="' + esc(x.name) + '">' + U.swatch(x.p)) + '</button></li>').join('') + '</ul></div>' +
          (sheet ? '' : '<button class="link shop-clear" type="button" data-clear>' + esc(W.shop_clear_filters) + '</button>');
      }
      function emptyHTML() {
        const col = colours(state.c).find(x => x.id === state.colour);
        const what = [col && col.name, state.size && fill(W.shop_size_named, { size: state.size })].filter(Boolean).join(', ');
        const n0 = noun(state.c);
        if (!what) return '<h2 class="t-title t-italic">' + esc(fill(W.shop_none_now, { noun: n0 })) + '</h2>' +   // the whole category is gone from the store
          '<div class="shop-empty-actions"><a class="btn btn-primary" href="' + shopUrl('all') + '">' + esc(W.shop_shop_all) + '</a></div>';
        const drop = (key, label) => {
          const n = matching({ ...state, [key]: null }).length;
          return n ? '<button class="btn btn-secondary" type="button" data-drop="' + key + '">' + label + ' <span class="n">' + n + '</span></button>' : '';
        };
        return '<h2 class="t-title t-italic">' + esc(fill(W.shop_none_in, { noun: n0, what })) + '</h2>' +
          '<p class="shop-empty-text">' + esc(W.shop_none_text) + '</p>' +
          '<div class="shop-empty-actions"><button class="btn btn-primary" type="button" data-clear>' + esc(W.shop_clear_filters) + '</button>' +
            (state.size && col ? drop('colour', esc(fill(W.shop_any_colour, { size: state.size }))) + drop('size', esc(fill(W.shop_any_size, { colour: col.name }))) : '') + '</div>' +
          '<p class="shop-empty-help">' + esc(W.shop_help) + ' <a href="' + esc(U.whatsapp(fill(W.shop_whatsapp, { noun: n0, what }))) +
            '" target="_blank" rel="noopener">' + esc(W.shop_help_link) + '</a>.</p>';
      }

      // ---------- render ----------
      function renderCategory() {
        const k = copy(state.c);
        if (band) {
          $('#shopTitle').textContent = k.title;
          $$('.shop-line').forEach(p => { p.hidden = true; });
          const line = k.own || $('.shop-line:not([data-c])');
          line.textContent = k.line;
          line.hidden = !k.line;
          $('.shop-note').textContent = k.note;
          if (W.shop_tab) document.title = fill(W.shop_tab, { page: state.c === 'all' && !COL ? W.shop_tab_all : k.title });
        }
        $$('[data-host]').forEach(h => { h.innerHTML = facetsHTML(h.dataset.host === 'sheet'); });
        U.markNav();   // the header and menu follow the category after pushState
      }
      function renderResults(changed) {
        const items = matching(state), n = items.length, on = !!state.size + !!state.colour;
        $$('#shopCats [data-c]').forEach(a => {
          a.href = query(inCat(state, a.dataset.c));
          a.dataset.c === state.c ? a.setAttribute('aria-current', 'page') : a.removeAttribute('aria-current');
        });
        $$('[data-f]').forEach(b => b.setAttribute('aria-pressed', String(state[b.dataset.f] === b.dataset.v)));
        const col = colours(state.c).find(x => x.id === state.colour);
        $$('[data-val]').forEach(el => { el.textContent = col ? col.name : ''; });
        $$('.shop-clear').forEach(b => { b.hidden = !on; });
        if ($('#filterBtn')) {
          const badge = $('#filterN');
          badge.hidden = !on; badge.textContent = on;
          $('#filterBtn').setAttribute('aria-label', on ? W.shop_filter + ', ' + fill(W.filters_on, { n: on }) : W.shop_filter);   // spoken name keeps the shown word
          $('#sort').value = state.sort;
          count.textContent = pieces(n);
          $('#sheetShow').textContent = n ? fill(W.shop_show, { pieces: pieces(n) }) : W.shop_nothing;
        }
        if (!grid) return;
        grid.hidden = !n; empty.hidden = !!n;
        const els = items.map(card);
        if (n && tile) {
          [2, 3, 4].forEach(k => tile.style.setProperty('--s' + k, span(n, k)));
          els.splice(n >= 8 ? 4 : n, 0, tile);
        }
        // only the shown cards stay in the grid, as if only they were printed: moved, not redrawn, so their photos stay
        // loaded, and the others wait outside the page (CARDS). The hidden tiles stay at the end, for the theme editor.
        grid.replaceChildren(...els, ...tiles.filter(t => !els.includes(t)));
        empty.innerHTML = n ? '' : emptyHTML();
        if (changed) { keepTop(); U.announce(n ? pieces(n) : W.nothing_matches); }
      }
      // When the filter bar is pinned, bring the top of the results back under it so a shorter list doesn't strand the reader.
      function keepTop() {
        if (!band) return;
        const head = document.querySelector('#siteHeader'), y = band.getBoundingClientRect().bottom + scrollY - (head ? head.offsetHeight : 0);
        if (scrollY > y) scrollTo(0, y);
      }

      // ---------- events ----------
      root.addEventListener('click', e => {
        const t = e.target.closest('[data-c], [data-f], [data-clear], [data-drop]');
        if (!t || t.matches('.shop-line')) return;
        if (t.dataset.c) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;          // new tab or window: let the link work
          e.preventDefault();
          if (t.dataset.c !== state.c) go(inCat(state, t.dataset.c), true);
          return;
        }
        if (t.dataset.f) { const f = t.dataset.f; go({ ...state, [f]: state[f] === t.dataset.v ? null : t.dataset.v }); }
        else if (t.dataset.drop) go({ ...state, [t.dataset.drop]: null });
        else go({ ...state, size: null, colour: null });
        if (count && (!t.isConnected || !t.getClientRects().length)) count.focus({ preventScroll: true });   // the control went away
      }, { signal });
      $('#sort')?.addEventListener('change', e => go({ ...state, sort: e.target.value }), { signal });
      $('#filterBtn')?.addEventListener('click', e => U.openPanel($('#filters'), e.currentTarget), { signal });
      addEventListener('popstate', () => {
        const next = read(), newCat = next.c !== state.c;
        state = next;
        if (newCat) renderCategory();
        renderResults(false);
      }, { signal });

      // ---------- start ----------
      // the chip of a category the address asks for shows even with nothing in it (Liquid hid it, or, for a product
      // type outside this collection, never printed it)
      const cats = $('#shopCats');
      if (cats && state.c !== 'all') {
        let chip = cats.querySelector('[data-c="' + CSS.escape(state.c) + '"]');
        if (!chip) {
          cats.insertAdjacentHTML('beforeend', '<a class="chip" data-c="' + esc(state.c) + '" href="' + shopUrl(state.c) + '">' +
            esc(CATS.find(x => x.id === state.c).label) + ' <span class="n">0</span></a>');
          chip = cats.lastElementChild;
        }
        chip.hidden = false;
      }
      renderCategory();
      renderResults(false);
      document.querySelectorAll('style[data-shop-first]').forEach(s => s.remove());   // the grid's first paint (blocks/_shop-grid): ours now
      try { history.replaceState(null, '', query(state)); } catch (e) { /* see go() */ }
    },
    select(block) {
      if (this.pick && block.matches('.shop-line[data-c]')) this.pick(block.dataset.c);
    }
  });
})();
